$(document).ready(function(){
    if (currentUrl.includes('auto-rates') && $('#shippingAutoRateCombination').length) {

        if ($.fn.DataTable.isDataTable('#shippingAutoRateCombination')) {
            $('#shippingAutoRateCombination').DataTable().clear().destroy();
        }
        const table = $('#shippingAutoRateCombination').DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            searching: false,
            paging: false,
            ordering: false,
            info: false,
            rowReorder: {
                selector: 'td.reorder',
                dataSrc: 'priority'
            },
            columns: [
                {
                    data: 'id',
                    name: 'id',
                    className: 'reorder'
                },
                {
                    data: 'carrier',
                    name: 'carrier',
                },
                {
                    data: 'carrier_type',
                    name: 'carrier_type',
                },
                {
                    data: 'carrier_service',
                    name: 'carrier_service',
                },
                {
                    data: 'carrier_package',
                    name: 'carrier_package',
                },
                {
                    data: 'price_handicap',
                    name: 'price_handicap',
                },
                {
                    data: 'id',
                    name: 'actions',
                    render: function(data, type, row) {
                        return `
                            <div class="mt-sm-0 mt-2 dropdown-toggle">
                                <a href="#" data-bs-toggle="dropdown" class="text-dark text-decoration-none">Actions <b class="caret"></b></a>

                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="/carriers/shipping/auto-rates/${data}/edit"><i class="fas fa-edit me-1"></i>Edit Combination</a>
                                    <div role="separator" class="dropdown-divider"></div>
                                    <a class="dropdown-item deleteCombinationBtn text-danger" href="javascript:void(0)" data-id="${data}"><i class="fas fa-trash me-1"></i>Delete</a>
                                </div>

                            </div>
                        `;
                    }
                }
            ],
            ajax: {
                url: "/carriers/shipping/auto-rates",
            }
        });

        table.on('row-reorder', function (e, diff, edit) {
            let reorderedData = [];
            let totalRows = table.rows().count();

            diff.forEach((change) => {
                let rowData = table.row(change.node).data();
                let newPriority = totalRows - change.newPosition;;

                reorderedData.push({
                    id: rowData.id,
                    priority: newPriority
                });
            });

            if (reorderedData.length > 0) {
                $.ajax({
                    url: '/carriers/shipping/auto-rates/reorder',
                    method: 'PUT',
                    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                    data: { combinations: reorderedData },
                    success: function(response) {
                        showNotification(
                            response.success ?
                            'Combination priority has been updated.' :
                            'Could not update Combination priority.',
                            response.success ?
                            'Updated!' :
                            'Error!'
                        );
                    },
                    error: function() {
                        showNotification('An error occurred while updating the Combination priority.', 'Error!');
                    }
                });
            }
        });
    }

    $(document).on('click', '.deleteCombinationBtn', function(e) {
        e.preventDefault();
        var combinationId = $(this).data('id');

        swal({
            title: 'Are you sure?',
            text: 'Delete this Combination!',
            icon: 'warning',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    value: null,
                    visible: true,
                    className: 'btn btn-default',
                    closeModal: true,
                },
                confirm: {
                    text: 'Delete',
                    value: true,
                    visible: true,
                    className: 'btn btn-danger',
                    closeModal: true
                }
            }
        }).then((result) => {
            if (result) {
                // User confirmed deletion
                $.ajax({
                    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                    method: 'delete',
                    url: `/carriers/shipping/auto-rates/${combinationId}`,
                    success: function(response) {
                        if(response.status == 'success'){
                            swal('Deleted!', response.message, 'success');
                        }else{
                            swal('Error!', 'Combination Not Found', 'error');
                        }
                        setTimeout(function () {
                            location.reload();
                        }, 200);
                    },
                    error: function(error) {
                        // Handle error
                        swal('Error!', 'An error occurred while deleting the Combination.', 'error');
                    }
                });
            }
        });
    });
});
